import { fetchLiveMainLine } from 'app/modules/Live/actions';
import { APPLY_STATE } from 'app/modules/Live/actions/liveHub';
import { isSSR } from 'app/packages/components';
import {
  SET_LIVE_GRID_ORDER_KEY,
  SET_LIVE_GRID_STAKE_TYPES,
} from 'app/redux/betting-presentation/grid/actions';
import createGridReducers from 'app/redux/betting-presentation/grid/reducers';

// ---

export const reduceGridPresentation = createGridReducers({
  APPLY_STATE: isSSR ? fetchLiveMainLine.fulfilled.toString() : APPLY_STATE,
  SET_GRID_ORDER_KEY: SET_LIVE_GRID_ORDER_KEY,
  SET_GRID_STAKE_TYPES: SET_LIVE_GRID_STAKE_TYPES,
});
